// Originally this was in index.js along side the component. But for some reason when its there Javascript can't figure
// out what the value is. And reads it as undefined. Simply moving it here completely fixes the problem for no reason.
export const WORKFORCENOW = 'wfn';

export const SendPayRates = 'sendPayRates';
export const sendPayRatesOption = 'sendPayRatesOption';
